import packageJson from '../../package.json';
import { Save, GenerateCSVSingle, GenerateCSVMultiple, getTemplateSelectionFromCookie } from '../components/export/csv';
import { updateViewOnly, getViewOnly } from '../contexts/AppContext';
import { ClubManufacturers, ConvertSubCategoryToPCCategory } from '../productData/clubData';
import { intToUppercaseLetter, getPublicIP,isValidTaskId } from '../utils/Utilities'
import { getTaskInfo, getTaskStatus, getValidBaseSN, getValidShaftSN, getValidHeadSN, getLoft, getComponentType, getValidMeasuredData } from './taskmanData';
import { GetVenueAdjustments } from './countryData';

import isdlAccessInstance from './isdlAccessInstance';
import { AppStateService } from '../contexts/AppState';

let appWorkingCount = 0;

const dispatchAppWorkingState = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent('appWorkingState', {
    detail: {
      active: appWorkingCount > 0,
      count: appWorkingCount
    }
  }));
};

const beginAppWorking = () => {
  appWorkingCount += 1;
  dispatchAppWorkingState();
};

const endAppWorking = () => {
  appWorkingCount = Math.max(0, appWorkingCount - 1);
  dispatchAppWorkingState();
};

const withAppWorking = async (operation) => {
  beginAppWorking();

  try {
    return await operation();
  } finally {
    endAppWorking();
  }
};

//POST

//Sessions_UpdateSession
export const upsertSession = async (data) => await isdlAccessInstance.sessionData.UpsertSession(data);


//GET

//Sessions_GetAllSessions
export const getSessions = async () => await isdlAccessInstance.sessionData.GetSessions();

//Sessions_GetBallSeriesFromTaskId
export const getBallSeriesFromTaskId = async (taskId) => await isdlAccessInstance.sessionData.GetBallSeriesFromTaskId(taskId);

//Sessions_GetDCSessions
export const getDCSessions = async (collectorId) => await isdlAccessInstance.sessionData.GetDCSessions(collectorId);

//Sessions_GetGolfersFromTaskId
export const getGolfersFromTaskId = async (taskId) => await isdlAccessInstance.sessionData.GetGolfersFromTaskId(taskId);

const ensureArray = (value) => Array.isArray(value) ? value : value ? [value] : [];

//Sessions_GetMiniDCSessionList //OBSOLETE
// export const getMiniDCSessionList = async (collectorId) => fetchData('/mini-dc', { collectorId });

//Sessions_GetMiniDCSessionList
export const getMiniDCSessionList = async (collectorId) =>
  ensureArray(await isdlAccessInstance.sessionData.GetMiniDCSessionList(collectorId));

//Sessions_GetMiniTaskSessionList
export const getMiniTaskSessionList = async (taskId) =>
  ensureArray(await isdlAccessInstance.sessionData.GetMiniTaskSessionList(taskId));

//Sessions_GetMiniDCSessionList
//export const getMiniDCSessionList = async (collectorId) => await isdlAccessInstance.sessionData.GetMiniDCSessionList(collectorId);

//Sessions_GetMiniTaskSessionList
//export const getMiniTaskSessionList = async (taskId) => await isdlAccessInstance.sessionData.GetMiniTaskSessionList(taskId);

//Sessions_GetSessionFromId
export const getSessionFromId = async (id) => await isdlAccessInstance.sessionData.GetSessionFromId(id);

//Sessions_GetSessionsFromTaskId
export const getSessionsFromTaskId = async (taskId) => await isdlAccessInstance.sessionData.GetSessionsFromTaskId(taskId);

//Sessions_GetUserSessions
export const getUserSessions = async (golferId, collectorId, taskId) => await isdlAccessInstance.sessionData.GetUserSessions(golferId, collectorId, taskId);

//Sessions_UserAndTaskIdExist
export const getUserAndTaskIdExist = async (userId, taskId) => await isdlAccessInstance.sessionData.GetUserAndTaskIdExist(userId, taskId);


//NON WEB CALLS

export const CurrentSessionHasBallSeries = () => {
  let currentSession = GetCurrentSession();
  return currentSession && currentSession.BallSeries && currentSession.BallSeries.length > 0;
}

export const CurrentSessionIsSoundSession = () => {
  let currentSession = GetCurrentSession();
  return currentSession && currentSession.SoundSession;
}

const COR_PLATE_TYPE = 'Plate';

export const IsPlateCorSetup = (setup) => setup?.TestParameters?.CORType === COR_PLATE_TYPE;
export const IsCorCannonSetup = (setup) => !!setup?.TestParameters?.CORType;

export const getDefaultCorPlateMass = (userName = '', userId = '') => {
  const normalized = `${String(userName || '').trim().toLowerCase()} ${String(userId || '').trim().toLowerCase()}`
    .replace(/[^a-z0-9]/g, '');

  if (normalized.includes('cannon1')) {
    return '189.3';
  }

  if (normalized.includes('cannon2')) {
    return '190.7';
  }

  return '190.7';
};

const cloneSessionSetupForNewSession = (setup, userName = '', userId = '') => {
  const preserveSetupId =
    setup?.Id === 'Setup Series' ||
    (typeof setup?.Id === 'string' && setup.Id.startsWith('Series '));

  const clonedSetup = {
    ...setup,
    Id: preserveSetupId ? setup.Id : generateGUID(),
    TestParameters: setup?.TestParameters ? { ...setup.TestParameters } : setup?.TestParameters,
    Shots: Array.isArray(setup?.Shots) ? setup.Shots.map((shot) => ({ ...shot })) : []
  };

  if (IsPlateCorSetup(clonedSetup)) {
    const existingCannonCor = clonedSetup.CannonCor || {};
    const existingInputs = existingCannonCor.inputs || {};

    clonedSetup.CannonCor = {
      ...existingCannonCor,
      inputs: {
        plateMass: existingInputs.plateMass ?? getDefaultCorPlateMass(userName, userId),
        plateBallMass: existingInputs.plateBallMass ?? '45.6',
        headMass: existingInputs.headMass ?? '',
        headBallMass: existingInputs.headBallMass ?? '45.6'
      }
    };
  } else if (IsCorCannonSetup(clonedSetup)) {
    const existingCannonCor = { ...(clonedSetup.CannonCor || {}) };
    delete existingCannonCor.inputs;

    if (Object.keys(existingCannonCor).length > 0) {
      clonedSetup.CannonCor = existingCannonCor;
    } else {
      delete clonedSetup.CannonCor;
    }
  }

  return clonedSetup;
};

const buildPlateCorSetup = (sourceSetup = null, isSelected = false) => ({
  Id: generateGUID(),
  LetterId: sourceSetup?.LetterId || '',
  ClubManufacturer: sourceSetup?.ClubManufacturer || 'Callaway Golf',
  ClubName: 'Plate',
  BaseComponentSN: sourceSetup?.BaseComponentSN || '',
  ClubId: sourceSetup?.ClubId || sourceSetup?.HeadSN || '',
  ClubDescription: COR_PLATE_TYPE,
  ClubCategory: sourceSetup?.ClubCategory || null,
  HeadSN: sourceSetup?.HeadSN || '',
  PCFamilyId: sourceSetup?.PCFamilyId || 'NONE',
  PCCategoryId: sourceSetup?.PCCategoryId || '1',
  ClubLoft: '',
  ShaftModel: '',
  ShaftPCCustomOptionId: '',
  ShaftSN: null,
  BallName: 'None',
  BallFamilyId: 'NONE',
  BallPrototypeId: null,
  IsSelected: isSelected,
  IsChecked: true,
  Shots: [],
  TaskmanImported: true,
  MeasuredLoft: null,
  MeasuredLie: null,
  MeasuredMass: null,
  MeasuredClubLength: null,
  MeasuredClubSwingWeight: null,
  MeasuredClubFrequency: null,
  TestParameters: {
    CORType: COR_PLATE_TYPE
  }
});

export const GetPlateSetupForCorSetup = (session, setup) => {
  if (!Array.isArray(session?.SessionSetups)) {
    return null;
  }

  if (IsPlateCorSetup(setup)) {
    return session.SessionSetups.find((candidate) => candidate?.Id === setup?.Id) || setup || null;
  }

  const plateSetups = session.SessionSetups.filter((candidate) => IsPlateCorSetup(candidate));
  if (plateSetups.length === 0) {
    return null;
  }

  const matchingByLetter = plateSetups.find((candidate) => {
    if (!candidate?.LetterId || !setup?.LetterId) {
      return false;
    }

    if (candidate.LetterId !== setup.LetterId) {
      return false;
    }

    const candidateHead = candidate.HeadSN || candidate.BaseComponentSN || '';
    const setupHead = setup.HeadSN || setup.BaseComponentSN || '';
    return !candidateHead || !setupHead || candidateHead === setupHead;
  });

  if (matchingByLetter) {
    return matchingByLetter;
  }

  return plateSetups.find((candidate) => !candidate?.LetterId) || plateSetups[0] || null;
};

export const EnsureCorPlateSetup = (session) => {
  if (!session || !Array.isArray(session.SessionSetups) || session.SessionSetups.length === 0) {
    return session;
  }

  const hasCorSetups = session.SessionSetups.some((setup) =>
    !!setup?.TestParameters?.CORType && setup.TestParameters.CORType !== ''
  );

  if (!hasCorSetups) {
    return session;
  }

  if (session.SessionSetups.some((setup) => IsPlateCorSetup(setup))) {
    return session;
  }

  const hasSelectedSetup = session.SessionSetups.some((setup) => setup?.IsSelected);
  const plateSetup = buildPlateCorSetup(null, !hasSelectedSetup);

  return {
    ...session,
    SessionSetups: [plateSetup, ...session.SessionSetups.map((setup) => ({ ...setup }))]
  };
};

var currentSession = null;

export const SetCurrentSession = (session) =>{
  // if(session !== null){
  //   const checkETags = async (session) => {
  //     // const curetag = (await getSessionFromId(session.id))._etag;
  //     // console.trace("LOCAL etag: " + session._etag);
  //     // console.trace("DB etag: " + curetag);
  //     console.log("etag updated " + session._etag);
  //     console.log("================");
  //   }
  //   checkETags(session);
  // }
    currentSession = session;

    const event = new CustomEvent('currentSessionUpdate', { detail: null });
    window.dispatchEvent(event);
};
export const GetCurrentSession = () => {
    return currentSession;
};
export const ResetSessions = () => {
    currentSession = null;
};

const upsertSessionImpl = async (session) => {

  if (!session.ModifiedBy) {
    session.ModifiedBy = [];
  }

  UpsertModifiedByList(
    session.ModifiedBy,
    await GetModifiedByObject('modified w')
  );

  // 3. Upsert with fresh etag
  const etag = await upsertSession(session);
  session._etag = etag;

  // 4. Store locally
  SetCurrentSession(session);

  return session;
};

let upsertLock = Promise.resolve();

/**
 * Exported safe UpsertSession:
 * - uses the passed-in session's changes
 * - always refreshes etag from server before writing
 * - never overlaps with another upsert from this client
 */
export const UpsertSession = (session) => {
  const run = () => withAppWorking(() => upsertSessionImpl(session));

  // Chain this run after whatever the previous upsert did
  upsertLock = upsertLock.then(run, run);

  return upsertLock; // so callers can still `await UpsertSession(...)`
};

const upsertSessionSilent = async (session, modifiedByItem = null) => {
  if (!session.ModifiedBy) {
    session.ModifiedBy = [];
  }

  if (modifiedByItem) {
    await UpsertModifiedByList(session.ModifiedBy, modifiedByItem);
  }

  const etag = await upsertSession(session);
  session._etag = etag;

  return session;
};

var currentSessionAdjustments = null;

export const SetCurrentSessionAdjustments = (adj) => {
  currentSessionAdjustments = adj;
};
export const GetCurrentSessionAdjustments = () => {
  return currentSessionAdjustments;
};
export const ResetSessionAdjustments = () => {
  currentSessionAdjustments = null;
};

export const LoadSession = async (id, justRetreiveData = false) => {
  beginAppWorking();

  try {
  let dbSession = await getSessionFromId(id);

  if (
    dbSession?.TaskmanImported
    && isValidTaskId(dbSession?.TaskID)
    && !dbSession?.TestParameters?.RobotFaceMap
  ) {
    try {
      const taskInfo = await getTaskInfo(dbSession.TaskID);
      if (taskInfo?.RobotTestInfo) {
        dbSession = {
          ...dbSession,
          TestParameters: {
            ...(dbSession.TestParameters || {}),
            RobotFaceMap: taskInfo.RobotTestInfo
          }
        };
      }
    } catch (e) {
      console.warn(`Unable to hydrate robot test parameters for task ${dbSession.TaskID}.`, e);
    }
  }

  const normalizedSession = EnsureCorPlateSetup(dbSession);
  if (normalizedSession !== dbSession) {
    dbSession = await upsertSessionSilent(normalizedSession);
  }

  //add viewed by object
  if(!dbSession.ModifiedBy){
    dbSession.ModifiedBy = [];
  }

  let isTaskAndIsCompleted = false;

  if(dbSession.TaskID !== null && dbSession.TaskID !== "" && isValidTaskId(dbSession.TaskID) || dbSession.TaskID !== undefined && dbSession.TaskID !== "" && isValidTaskId(dbSession.TaskID)){
    try{
      const value = await getTaskStatus(dbSession.TaskID);
      isTaskAndIsCompleted = value.TaskStatus === "Completed";
    }catch{
      console.warn("Task status for " + dbSession.TaskID + " can't be found. Ignoring!");
    }
  }

  UpsertModifiedByList(dbSession.ModifiedBy, await GetModifiedByObject('loaded'));

  if(!justRetreiveData){

    const sessionAdj = await GetVenueAdjustments(dbSession.VenueName, dbSession.Date);
    SetCurrentSessionAdjustments(sessionAdj);

    const sessionData = 
    {
        Id:dbSession.id,
        Description:dbSession.Description ? dbSession.Description : "",
        Date:dbSession.Date,
        TaskID:dbSession.TaskID ? dbSession.TaskID : "",
        ProjectId:dbSession.ProjectId ? dbSession.ProjectId : ""
    };
  
    localStorage.setItem('savedLastSession', JSON.stringify(sessionData));

    let viewOnlySession = false;

    if(dbSession.TaskFinished){
      viewOnlySession = true;
    }

    if(isTaskAndIsCompleted){
      viewOnlySession = true;
      dbSession.TaskFinished = true;
    }

    if(getViewOnly()){
      viewOnlySession = true;
    }

    updateViewOnly(viewOnlySession);
  
    SetCurrentSession(dbSession);
  }
  
  return dbSession;
  } finally {
    endAppWorking();
  }
}

export const ChangePlayerSession = async (golferId, dataCollectorId, taskId) => {
  const sessions = await getUserSessions(golferId, dataCollectorId, taskId);
  const sessionLoaded = sessions[0];

  const sessionAdj = await GetVenueAdjustments(sessionLoaded.VenueName, sessionLoaded.Date);
    SetCurrentSessionAdjustments(sessionAdj);

  const sessionData = 
  {
      Id:sessionLoaded.id,
      Description:sessionLoaded.Description ? sessionLoaded.Description : "",
      Date:sessionLoaded.Date,
      TaskID:sessionLoaded.TaskID ? sessionLoaded.TaskID : "",
      ProjectId:sessionLoaded.ProjectId ? sessionLoaded.ProjectId : ""
  };

  localStorage.setItem('savedLastSession', JSON.stringify(sessionData));

  SetCurrentSession(sessionLoaded);

  return sessionLoaded;
}

export const ChangeSession = async (sessionId) => {
  const session = await getSessionFromId(sessionId);
  if (!session.ModifiedBy) {
    session.ModifiedBy = [];
  }

//add viewed by object
  UpsertModifiedByList(session.ModifiedBy, await GetModifiedByObject('opened'));

  const sessionAdj = await GetVenueAdjustments(session.VenueName, session.Date);
  SetCurrentSessionAdjustments(sessionAdj);

  const sessionData = 
  {
      Id:session.id,
      Description:session.Description ? session.Description : "",
      Date:session.Date,
      TaskID:session.TaskID ? session.TaskID : "",
      ProjectId:session.ProjectId ? session.ProjectId : ""
  };

  localStorage.setItem('savedLastSession', JSON.stringify(sessionData));

  SetCurrentSession(session);

  return session;
}

export const CreateNewSession = async (data) => {

  data["ModifiedBy"] = [await GetModifiedByObject('created')];

  let newSession = createNewSessionObject(data, "LMReceiverWeb");

  SetCurrentSession(newSession);

  const sessionAdj = await GetVenueAdjustments(newSession.VenueName, newSession.Date);
  SetCurrentSessionAdjustments(sessionAdj);

  //set last session info
  const sessionData = 
  {
      Id: newSession.id,
      Description: newSession.Description ? newSession.Description : "",
      Date: newSession.Date,
      TaskID: newSession.TaskID ? newSession.TaskID : "",
      ProjectId: newSession.ProjectId ? newSession.ProjectId : ""
  };


  localStorage.setItem('savedLastSession', JSON.stringify(sessionData));
  await UpsertSession(newSession);

  return newSession;
};

export const CreateNewSessionWithGolfers = async (data, golfers) => {
  let firstSession = null;

  for(let i = 0; i < golfers.length; i++){
    let golfer = golfers[i];

    data["Golfer"] = golfer;
    data["ModifiedBy"] = [await GetModifiedByObject('created')];

    let newSession = createNewSessionObject(data, "LMReceiverWeb");

    const sessionAdj = await GetVenueAdjustments(newSession.VenueName, newSession.Date);
    SetCurrentSessionAdjustments(sessionAdj);

    await UpsertSession(newSession);

    console.log(newSession);

    if(firstSession === null){
      firstSession = newSession;
    }
  }

  SetCurrentSession(firstSession);

  //set last session info
  const sessionData = 
  {
      Id: firstSession.id,
      Description: firstSession.Description ? firstSession.Description : "",
      Date: firstSession.Date,
      TaskID: firstSession.TaskID ? firstSession.TaskID : "",
      ProjectId: firstSession.ProjectId ? firstSession.ProjectId : ""
  };

  localStorage.setItem('savedLastSession', JSON.stringify(sessionData));

  return firstSession;
};

export const CreateTaskSession = async (taskId, taskData, taskTypeData, golfers, datacollector, venue) => {
  let description = taskData.proj_title;
  let components = taskData.components;
  const test_type = (taskData.task_type  && typeof taskData.task_type === "string") ? taskData.task_type.toLowerCase() : "club";
  const entityType = test_type === "robot" ? "Test" : "Golfer";
  let is_sound = false;
  is_sound = (taskData.is_sound && typeof taskData.is_sound === "boolean" && taskData.is_sound === true);
  const usesCorCannon =
    taskData.cor_use_center === true ||
    taskData.cor_use_hot_spot === true;

  let has_robot_params = taskData.hasOwnProperty('RobotTestInfo');
  let robot_params = has_robot_params ? taskData.RobotTestInfo : null;

  let test_params = {};

  if(robot_params){
    test_params['RobotFaceMap'] = robot_params;
  }

  let setups = [];
  let ballSeries = null;

  if (test_type !== "robot") {//"robot" means its a ball series test (eyeroll)
    for (let i = 0; i < components.length; i++) {
      let taskItem = components[i];
      const letter = intToUppercaseLetter(taskItem.index);
      let validTasks = [];
      let plateSetup = null;

      if (usesCorCannon) {
        plateSetup = buildPlateCorSetup({
          LetterId: letter,
          ClubManufacturer: taskItem.brand,
          ClubCategory: taskItem.category,
          BaseComponentSN: getValidBaseSN(taskItem, null),
          ClubId: getValidHeadSN(taskItem, null),
          HeadSN: getValidHeadSN(taskItem, null),
          PCFamilyId: "PROTOTYPE",
          PCCategoryId: ConvertSubCategoryToPCCategory(taskItem.category)
        }, i === 0);
        setups.push(plateSetup);
      }

      if (usesCorCannon) {
        validTasks = ["Center", "Hot Spot", "Other"];
      } else {
        switch (test_type) {
          case "club": {
            validTasks.push(getValidBaseSN(taskItem, null));
            break;
          }
          case "robot cpas & rbc": {
            if (taskTypeData) {
              validTasks = taskTypeData.map((d) => d.Name);
            } else {
              validTasks.push(getValidBaseSN(taskItem, null));
            }
            break;
          }
          default: {
            validTasks.push(getValidBaseSN(taskItem, null)); 
            break;
          }
        }
      }

      for (let j = 0; j < validTasks.length; j++) {
        let setupTestData = {};

        if (usesCorCannon) {
          setupTestData.CORType = validTasks[j];
        }

        if (taskTypeData && (test_type === "face map" || test_type === "c/t/h" || test_type === "robot cpas & rbc")) {
          setupTestData.RobotFaceMap = taskTypeData.find((item) => item.Name === validTasks[j]);
        }
        if (usesCorCannon) {
          setupTestData['CORType'] = validTasks[j];
        }

        let setup = {
          Id: generateGUID(),
          LetterId: letter,
          ClubManufacturer: taskItem.brand,
          ClubName: "Prototype",
          BaseComponentSN: getValidBaseSN(taskItem, null),
          ClubId: getValidHeadSN(taskItem, null),
          ClubDescription: validTasks[j],//typeof taskItem.description === "string" ? taskItem.description : "",
          ClubCategory: taskItem.category,
          HeadSN: getValidHeadSN(taskItem, null),
          PCFamilyId: "PROTOTYPE",
          PCCategoryId: ConvertSubCategoryToPCCategory(taskItem.category),
          ClubLoft: getLoft(taskItem),
          ShaftModel: null,
          ShaftPCCustomOptionId: null,
          ShaftSN: getValidShaftSN(taskItem, null),
          BallName: "None",
          BallFamilyId: "NONE",
          BallPrototypeId: null,
          IsSelected: usesCorCannon ? false : i === 0 && j === 0 ? true : false,
          IsChecked: true,
          Shots: [],
          TaskmanImported: true,
          MeasuredLoft: getValidMeasuredData(taskItem.loft_meas, "number", null),
          MeasuredLie: getValidMeasuredData(taskItem.lie_meas, "number", null),
          MeasuredMass: getValidMeasuredData(taskItem.mass, "number", null),
          MeasuredClubLength: getValidMeasuredData(taskItem.club_length, "number", null),
          MeasuredClubSwingWeight: getValidMeasuredData(taskItem.club_sw, "string", null),
          MeasuredClubFrequency: getValidMeasuredData(taskItem.club_freq, "number", null),
          TestParameters: setupTestData
        };
        setups.push(setup);
      }
    }
  } else {//this is the ball series setup creation
    ballSeries = [];

    //add ball series to the list on the session
    for (let j = 0; j < components.length; j++) {
      let ballSeriesItem = components[j];
      if (ballSeriesItem.group_num) {
        ballSeries.push(ballSeriesItem.group_num);
      }
    }

    //add setup series/series nums
    for (let i = -1; i < taskData.quantity; i++) {
      let setup = {
        Id: i == -1 ? "Setup Series" : `Series ${(i + 1).toString()}`,
        LetterId: "",
        ClubManufacturer: "Callaway Golf",
        ClubName: "",
        BaseComponentSN: "",
        ClubId: "",
        ClubDescription: "",
        ClubCategory: null,
        HeadSN: "",
        PCFamilyId: "NONE",
        PCCategoryId: "1",
        ClubLoft: "",
        ShaftModel: "",
        ShaftPCCustomOptionId: "",
        ShaftSN: null,
        BallName: "Ball Series Testing",
        BallFamilyId: "BALLSERIES",
        BallPrototypeId: null,
        IsSelected: i === -1 ? true : false,
        IsChecked: true,
        Shots: [],
        TaskmanImported: true,
        MeasuredLoft: null,
        MeasuredLie: null,
        MeasuredMass: null,
        MeasuredClubLength: null,
        MeasuredClubSwingWeight: null,
        MeasuredClubFrequency: null,
        TestParameters: null
      };
      setups.push(setup);
    }
  }

  


  let sessions = [];
  const appState = AppStateService.getSnapshot();
  const sessionEntities = Array.isArray(golfers) ? golfers : [];

  for(let i = 0; i < sessionEntities.length; i++){
    let golfer = sessionEntities[i];
    const entityId = entityType === "Test" ? golfer.value : golfer.id;
    const entityName = entityType === "Test" ? golfer.label : golfer.FullName;
    const entityHandicap = entityType === "Test" ? null : golfer.Handicap;

    let session = {
      id : generateGUID(),
      TaskID : taskId,
      Description : description,
      ProjectID : "",
      TestID : entityType === "Test" ? entityId : "",
      DataSource : "LMReceiverWeb",//need to update
      DataCollectorId : datacollector.id,
      DataCollectorName : datacollector.FullName,
      UserId : entityId,
      UserName : entityName,
      UserHandicap: Number.isFinite(golfer.Handicap) ? golfer.Handicap : -9999,
      VenueID : venue.VenueId,//may need this?
      VenueName : venue.Name, //this too?
      SiteID : null,
      Date: formatDateUTC(),
      DateLocal: formatDateLocal(),
      WebDataVersion: packageJson.version,
      AppDataVersion: appState.InApp ? appState.AppVersion : "0.0.0.0",
      PressureMmHg: null,
      TemperatureF: null,
      Humidity: null,
      WindDirection: null,
      WindSpeedMph: null,
      LaunchMonitorMode: "Outdoor",
      BallSeries: ballSeries,
      EntityType: entityType,
      CurrentTarget: null,
      Targets: null,
      CurrentBay: null,
      Bays: null,
      SessionSetups: setups.map((setup) => cloneSessionSetupForNewSession(setup, entityName, entityId)),
      TaskFinished: false,
      TaskmanImported : true,
      SoundSession : is_sound,
      ModifiedBy: [
        await GetModifiedByObject('created')
      ],
      TestParameters: test_params,
    };
    sessions.push(session);
  }

  //  console.log(sessions);

  for(let i = sessions.length - 1; i >= 0; i--){
    let dataToUpload = sessions[i];
    await UpsertSession(dataToUpload);
  }

  let startingSession = sessions[0];

  const sessionAdj = await GetVenueAdjustments(startingSession.VenueName, startingSession.Date);
  SetCurrentSessionAdjustments(sessionAdj);

  // // // console.log(startingSession);

  SetCurrentSession(startingSession);

  // //set last session info
  // const sessionData = 
  // {
  //     Id: startingSession.id,
  //     Description: startingSession.Description ? startingSession.Description : "",
  //     Date: startingSession.Date,
  //     TaskID: startingSession.TaskID ? startingSession.TaskID : "",
  //     ProjectId: startingSession.ProjectId ? startingSession.ProjectId : ""
  // };


  // localStorage.setItem('savedLastSession', JSON.stringify(sessionData));

}

export const CopyCurrentSession = async (newGolfer) => {
  const oldSession = GetCurrentSession();
  const appState = AppStateService.getSnapshot();

  const newSessionDetails = {
      id: generateGUID(),
      UserId: newGolfer.id,
      UserName: newGolfer.FullName,
      UserHandicap: Number.isFinite(newGolfer.Handicap) ? newGolfer.Handicap : -9999,
      
      Date: formatDateUTC(),
      DateLocal: formatDateLocal(),
      WebDataVersion: packageJson.version,
      AppDataVersion: appState.InApp ? appState.AppVersion : "0.0.0.0",
      DataSource: "LMReceiverWeb",
  };

  const newSession = copyExistingSession(oldSession, newSessionDetails);

  const sessionAdj = await GetVenueAdjustments(newSession.VenueName, newSession.Date);
  SetCurrentSessionAdjustments(sessionAdj);

  SetCurrentSession(newSession);
  await UpdateCurrentSession();

  return newSession;
}

export const CopyCurrentSessionWithTest = async (newTest) => {
  const oldSession = GetCurrentSession();
  const appState = AppStateService.getSnapshot();

  const newSessionDetails = {
      id: generateGUID(),
      EntityType: "Test",
      TestID: newTest.value,
      UserId: newTest.value,
      UserName: newTest.label,
      UserHandicap: Number.isFinite(newTest.Handicap) ? newTest.Handicap : -9999,
      Date: formatDateUTC(),
      DateLocal: formatDateLocal(),
      WebDataVersion: packageJson.version,
      AppDataVersion: appState.InApp ? appState.AppVersion : "0.0.0.0",
      DataSource: "LMReceiverWeb",
  };

  const newSession = copyExistingSession(oldSession, newSessionDetails);

  const sessionAdj = await GetVenueAdjustments(newSession.VenueName, newSession.Date);
  SetCurrentSessionAdjustments(sessionAdj);

  SetCurrentSession(newSession);
  await UpdateCurrentSession();

  return newSession;
}

export const CreateNewCopyOfSession = async (newGolfer, oldSessionId) => {
  const oldSession = await LoadSession(oldSessionId, true);
  const appState = AppStateService.getSnapshot();

  const newSessionDetails = {
    id: generateGUID(),
    UserId: newGolfer.id,
    UserName: newGolfer.FullName,
    UserHandicap: Number.isFinite(newGolfer.Handicap) ? newGolfer.Handicap : -9999,
    Date: formatDateUTC(),
    DateLocal: formatDateLocal(),
    WebDataVersion: packageJson.version,
    AppDataVersion: appState.InApp ? appState.AppVersion : "0.0.0.0",
    DataSource: "LMReceiverWeb",
  };

  const newSession = copyExistingSession(oldSession, newSessionDetails);

  const sessionAdj = await GetVenueAdjustments(newSession.VenueName, newSession.Date);
  SetCurrentSessionAdjustments(sessionAdj);

  SetCurrentSession(newSession);
  await UpdateCurrentSession();

  return newSession;
}

export const CloneSession = async (oldSession, newSessionData) => {
  const newSession = copyExistingSession(oldSession, newSessionData);

  SetCurrentSession(newSession);
  await UpdateCurrentSession();
  return newSession;
}

export const ResetTaskSessions = async () => {
  const currentSession = GetCurrentSession();

  if (!currentSession || !isValidTaskId(currentSession.TaskID)) {
    return { valid: false, reason: 'invalid_task' };
  }

  const taskId = currentSession.TaskID;
  const sessionList = await getSessionsFromTaskId(taskId);
  const sessionIds = Array.isArray(sessionList) ? sessionList : (sessionList ? [sessionList] : []);

  if (sessionIds.length === 0) {
    return { valid: false, reason: 'no_sessions' };
  }

  const normalizeSessionId = (entry) => {
    if (typeof entry === 'string') {
      return entry;
    }
    if (entry && typeof entry === 'object') {
      return entry.id ?? entry.Id ?? entry.ID ?? null;
    }
    return null;
  };

  const sessions = (await Promise.all(
    sessionIds.map(async (entry) => {
      if (entry && typeof entry === 'object' && entry.SessionSetups) {
        return entry;
      }
      const sessionId = normalizeSessionId(entry);
      if (!sessionId) {
        return null;
      }
      return await getSessionFromId(sessionId);
    })
  )).filter(Boolean);

  if (!sessions.find(session => session.id === currentSession.id)) {
    sessions.unshift(currentSession);
  }

  const archiveTag = '[archived]';
  const appendArchivedTag = (description) => {
    const normalized = (description ?? '').trim();
    if (normalized === '') {
      return archiveTag;
    }
    if (/\[archived\]/i.test(normalized)) {
      return normalized;
    }
    return `${normalized} ${archiveTag}`;
  };

  const archivedTaskId = generateGUID();
  const createdBy = await GetModifiedByObject('created');
  const modifiedBy = await GetModifiedByObject('modified w');
  const nowUtc = formatDateUTC();
  const nowLocal = formatDateLocal();
  const appState = AppStateService.getSnapshot();

  const newSessions = sessions.map((session) => {
    const newSessionDetails = {
      id: generateGUID(),
      TaskID: taskId,
      Date: nowUtc,
      DateLocal: nowLocal,
      WebDataVersion: packageJson.version,
      AppDataVersion: appState.InApp ? appState.AppVersion : "0.0.0.0",
      DataSource: "LMReceiverWeb",
      TaskFinished: false,
      ModifiedBy: []
    };

    const newSession = copyExistingSession(session, newSessionDetails);
    return { oldId: session.id, session: newSession };
  });

  for (const entry of newSessions) {
    await upsertSessionSilent(entry.session, createdBy);
  }

  for (const session of sessions) {
    const archivedSession = {
      ...session,
      TaskID: archivedTaskId,
      Description: appendArchivedTag(session.Description)
    };

    await upsertSessionSilent(archivedSession, modifiedBy);
  }

  const currentClone = newSessions.find(entry => entry.oldId === currentSession.id)?.session
    ?? newSessions[0]?.session;

  return { valid: true, session: currentClone, archivedTaskId };
}

export const UpdateShotCheck = async (setup, shot, isChecked, updateDb = true) => {
  let currentSession = GetCurrentSession();

  SetCurrentSession(CheckShotFunc(currentSession, setup, shot, isChecked));

  if(updateDb){
    await UpdateCurrentSession({
        origin:'checkShot',
        func:CheckShotFunc,
        params:{
          setup:setup,
          shot:shot,
          isChecked: isChecked
        }
      }
    );
  }
}

function CheckShotFunc(session, setup, shot, isChecked){
  let updatedSession = session;
  let currentSetup = updatedSession.SessionSetups.find(s => s.Id === setup.Id);
  let currentShot = currentSetup.Shots.find(s => s.ShotNumber === shot.ShotNumber);
  currentShot.IsChecked = isChecked;

  currentSetup.Shots = currentSetup.Shots.map(s =>
      s.ShotNumber === currentShot.ShotNumber ? currentShot : s
  );

  updatedSession.SessionSetups = updatedSession.SessionSetups.map(s =>
      s.Id === currentSetup.Id ? currentSetup : s
  );

  return updatedSession;
}

export const CheckAllShots = async (setup, isChecked, updateDb = false) => {
  let currentSession = GetCurrentSession();

  SetCurrentSession(CheckAllShotsFunc(currentSession, setup, isChecked));

if(updateDb){
    await UpdateCurrentSession({
        origin:'checkAllShots',
        func:CheckAllShotsFunc,
        params:{
          setup:setup,
          isChecked: isChecked
        }
      }
    );
  }
}

function CheckAllShotsFunc(session, setup, isChecked){
  let updatedSession = session;
  let currentSetup = updatedSession.SessionSetups.find(s => s.Id === setup.Id);
  let newShots = currentSetup.Shots.map(s => ({ ...s, IsChecked: isChecked }));
  currentSetup.Shots = newShots;
  currentSession.SessionSetups = currentSession.SessionSetups.map(s =>
    s.Id === currentSetup.Id ? currentSetup : s
  );
  return updatedSession;
}

export const UpdateSetup = async (setup, keyvalues) => {
  let currentSession = GetCurrentSession();

  SetCurrentSession(UpdateSetupFunc(currentSession, setup, keyvalues));
  await UpdateCurrentSession({
        origin:'updateSetup',
        func:UpdateSetupFunc,
        params:{
          setup:setup,
          keyvalues: keyvalues
        }
      }
    );
}

export const UpdateCannonCorData = async (cannonCor) => {
  let currentSession = GetCurrentSession();

  SetCurrentSession(UpdateCannonCorDataFunc(currentSession, cannonCor));
  await UpdateCurrentSession({
        origin:'updateCannonCor',
        func:UpdateCannonCorDataFunc,
        params:{
          cannonCor:cannonCor
        }
      }
    );
}

function UpdateCannonCorDataFunc(session, cannonCor){
  let currentSession = session;
  currentSession.CannonCor = {
    ...(currentSession.CannonCor || {}),
    ...(cannonCor || {})
  };
  return currentSession;
}

function UpdateSetupFunc(session, setup, keyvalues){
  let currentSession = session;
  currentSession.SessionSetups = currentSession.SessionSetups.map(s =>
    s.Id === setup.Id
      ? { 
          ...s,        // copy everything
          ...keyvalues   // overwrite only those fields present
        }
      : s
  );
  return currentSession;
}

export const CloneSetup = async (setup, newUpdates) => {
  let currentSession = GetCurrentSession();

  SetCurrentSession(CloneSetupFunc(currentSession, setup, newUpdates));
  await UpdateCurrentSession({
        origin:'cloneSetup',
        func:CloneSetupFunc,
        params:{
          setup:setup,
          newUpdates: newUpdates
        }
      });

  return GetCurrentSession().SessionSetups.find(s => s.Id === setup.Id);
}

function CloneSetupFunc(session, setup, newUpdates){
  let currentSession = session;
  let cloningSetupIndex = currentSession.SessionSetups.findIndex(s => s.Id === setup.Id);

  let newSetup = {
    ...setup,
    Id : generateGUID(),
    ...newUpdates,
    Shots:[],
    TaskmanImported : false
  };

  if(cloningSetupIndex !== -1){
    currentSession.SessionSetups.splice(cloningSetupIndex + 1, 0, newSetup);
  }

  return currentSession;
}

export const DeleteSessionSetup = async (setupId) => {
  let currentSession = GetCurrentSession();

  SetCurrentSession(DeleteSessionSetupFunc(currentSession, setupId));

  await UpdateCurrentSession({
        origin:'deleteSetup',
        func:DeleteSessionSetupFunc,
        params:{
          setupId:setupId
        }
      });
};

function DeleteSessionSetupFunc(session, setupId){
  let currentSession = session;
  let newSetups = currentSession.SessionSetups.filter(setup => setup.Id !== setupId);
  currentSession.SessionSetups = newSetups;
  return currentSession;
}

export const DeleteShotFromSession = async (setupId, shotNumber) => {
  let currentSession = GetCurrentSession();

  SetCurrentSession(DeleteShotFromSessionFunc(currentSession, setupId, shotNumber));

  await UpdateCurrentSession({
        origin:'deleteShot',
        func:DeleteShotFromSessionFunc,
        params:{
          setupId:setupId,
          shotNumber:shotNumber
        }
      });
};

function DeleteShotFromSessionFunc(session, setupId, shotNumber){
  let currentSession = session;
  let currentSetup = currentSession.SessionSetups.find(setup => setup.Id === setupId);
  let newShots = currentSetup.Shots.filter(shot => shot.ShotNumber !== shotNumber);

  currentSetup.Shots = newShots;
  currentSession.SessionSetups.map(setup => setup.Id === currentSetup.Id ? currentSetup : setup);
  return currentSession;
}

export const AddSessionSetup = async (setup) => {
  let currentSession = GetCurrentSession();

  SetCurrentSession(AddSessionSetupFunc(currentSession, setup));
  await UpdateCurrentSession({
        origin:'addSessionSetup',
        func:AddSessionSetupFunc,
        params:{
          setup:setup
        }
      });
}

function AddSessionSetupFunc(session, setup){
  let currentSession = session;

  if(!currentSession.SessionSetups){
      currentSession.SessionSetups = [];
  }else{
    const updatedSetups = currentSession.SessionSetups.map(s => ({ ...s, IsSelected: false }));
    currentSession.SessionSetups = updatedSetups;
  }

  setup.IsSelected = true;
  currentSession.SessionSetups.push(setup);

  return currentSession;
}

export const AddSessionSetupsAndSeries = async (setups, series) => {
  let currentSession = GetCurrentSession();

  SetCurrentSession(AddSessionSetupsAndSeriesFunc(currentSession, setups, series));
  await UpdateCurrentSession({
        origin:'addSessionSetupSeries',
        func:AddSessionSetupsAndSeriesFunc,
        params:{
          setups:setups,
          series:series
        }
      });
}

function AddSessionSetupsAndSeriesFunc(session, setups, series){
  let currentSession = session;
  currentSession.BallSeries = series;

  if(!currentSession.SessionSetups){
      currentSession.SessionSetups = [];
  }
    
  for(let i = 0; i < setups.length; i++){
      currentSession.SessionSetups.push(setups[i]);
    }
  

  return currentSession;
}

export const SelectSessionSetup = async (session, setup, updateDb) => {

  SetCurrentSession(SelectSessionSetupFunc(session, setup));
  if(updateDb){
    await UpdateCurrentSession(
    {
        origin:'selectSetup',
        func:SelectSessionSetupFunc,
        params:{
          setup:setup
        }
      });
  }
}

function SelectSessionSetupFunc(session, setup){
  const updatedSession = session;
  const updatedSetups = updatedSession.SessionSetups.map(s => ({ ...s, IsSelected: s.Id === setup.Id }));
  updatedSession.SessionSetups = updatedSetups;
  return updatedSession;
}

export const CheckAllSessionSetup = async (isChecked, updateDb) => {
  let currentSession = GetCurrentSession();
  SetCurrentSession(CheckAllSessionSetupFunc(currentSession, isChecked));
  if (updateDb) {
    await UpdateCurrentSession(
      {
        origin: 'checkAllSetups',
        func: CheckAllSessionSetupFunc,
        params: {
          isChecked: isChecked
        }
      }
    );
  }
}

function CheckAllSessionSetupFunc(session, isChecked){
  let currentSession = session;
  currentSession.SessionSetups = currentSession.SessionSetups.map(s => ({...s, IsChecked: isChecked}));
  return currentSession;
}

export const CheckSessionSetup = async (session, setup, isChecked, updateDb = true) => {
  SetCurrentSession(CheckSessionSetupFunc(session,setup, isChecked));

  if(updateDb){
    await UpdateCurrentSession(
      {
        origin:'checkSetup',
        func:CheckSessionSetupFunc,
        params:{
          setup:setup,
          isChecked: isChecked
        }
      }
    );
  }
}

function CheckSessionSetupFunc(session, setup, isChecked){
  const updatedSession = session;

  const updatedSetups = updatedSession.SessionSetups.map(s => s.Id === setup.Id ? { ...s, IsChecked: isChecked } : s);

  updatedSession.SessionSetups = updatedSetups;

  return updatedSession;
}

export const AddSetups = async (setups) => {
  let currentSession = GetCurrentSession();

  if(!currentSession.SessionSetups)
      currentSession.SessionSetups = [];

  for(let i = 0; i < setups.length; i++){
      currentSession.SessionSetups.push(setups[i]);
  }

  SetCurrentSession(currentSession);
  await UpdateCurrentSession();
}

export function GetSetupDescription(setup){
  let clubString = "";
  if (setup.ClubName === "Prototype") {

      if(setup.LetterId && setup.LetterId !== ""){
        clubString += setup.LetterId + ": ";
      }

      // clubString = setup.ClubId;
      if(setup.ClubDescription){
          clubString += setup.ClubDescription;
      }else{
          clubString += setup.ClubId;
      }
  } else if (setup.ClubName === "Custom") {
      clubString = setup.ClubName + (setup.ClubId ? ` [${setup.ClubId}]` : "");
  } else {
      clubString = setup.ClubName;
  }

  let ballString = "";
  if(setup.BallName === "Prototype"){
      if(setup.Id === "Setup Series" || setup.Id.includes("Series ")){
          clubString = null;
          ballString = setup.Id;
      }else{
          ballString = setup.BallName + !setup.BallPrototypeId ? "" : ("[" + setup.BallPrototypeId + "]");
      }
  }else if(setup.BallName === "Ball Series Testing"){
      if(setup.Id === "Setup Series" || setup.Id.includes("Series ")){
          clubString = null;
          ballString = setup.Id;
      }else{
          ballString = setup.BallName + !setup.BallPrototypeId ? "" : ("[" + setup.BallPrototypeId + "]");
      }
  }else if(setup.BallName === "None"){
      ballString = "";
  }else{
      ballString = setup.BallName;
  }

  if(clubString && ballString)
    return clubString + " " + ballString;
  else if(clubString && !ballString)
    return clubString;
  else
    return ballString;
}

export const GetNextShotNumberFromSetup = (setup) =>{
  if(setup.Shots && setup.Shots.length > 0){
    let LastShotNumber = Math.max(...setup.Shots.map(shot => parseInt(shot.ShotNumber,10))) + 1;
    return LastShotNumber;
  }else{
    return 1;
  }
  
}

export const MoveShotFromToSetup = async (oldSetupId, newSetupId, shotNumber) => {
  const currentSession = GetCurrentSession();

  SetCurrentSession(MoveShotFromToSetupFunc(currentSession, oldSetupId, newSetupId, shotNumber));

  await UpdateCurrentSession({
        origin:'moveShot',
        func:MoveShotFromToSetupFunc,
        params:{
          oldSetupId:oldSetupId,
          newSetupId: newSetupId,
          shotNumber:shotNumber
        }
      });
}

export const CopyShotInSetup = async (setupId, shotNumber) => {
  const currentSession = GetCurrentSession();

  SetCurrentSession(CopyShotInSetupFunc(currentSession, setupId, shotNumber));

  await UpdateCurrentSession({
        origin:'copyShot',
        func:CopyShotInSetupFunc,
        params:{
          setupId: setupId,
          shotNumber: shotNumber
        }
      });
}

function CopyShotInSetupFunc(session, setupId, shotNumber){
  const currentSession = session;
  const currentSetup = currentSession.SessionSetups.find(setup => setup.Id === setupId);

  if (!currentSetup || !Array.isArray(currentSetup.Shots)) {
    return currentSession;
  }

  const sourceShot = currentSetup.Shots.find(shot => shot.ShotNumber === shotNumber);

  if (!sourceShot) {
    console.error(`ShotNumber ${shotNumber} not found in setup ${setupId}.`);
    return currentSession;
  }

  const copiedShot = JSON.parse(JSON.stringify(sourceShot));
  copiedShot.ShotNumber = GetNextShotNumberFromSetup(currentSetup);

  currentSetup.Shots.push(copiedShot);
  currentSession.SessionSetups.map(setup => setup.Id === currentSetup.Id ? currentSetup : setup);

  return currentSession;
}

const cloneShotForImport = (shot, shotNumber) => {
  const clonedShot = JSON.parse(JSON.stringify(shot || {}));
  clonedShot.ShotNumber = shotNumber;
  return clonedShot;
};

const buildImportedPlateShots = (sourceShots = [], startingShotNumber = 1) => {
  if (!Array.isArray(sourceShots) || sourceShots.length === 0) {
    return [];
  }

  let nextShotNumber = startingShotNumber;

  return sourceShots.map((shot) => {
    const clonedShot = cloneShotForImport(shot, nextShotNumber);
    nextShotNumber += 1;
    return clonedShot;
  });
};

function ImportPlateShotsFromSessionFunc(targetSession, sourceSession, options = {}) {
  const currentSession = targetSession;

  if (!currentSession || !sourceSession) {
    throw new Error('Both source and target sessions are required.');
  }

  const targetPlateSetup = options.targetSetupId
    ? currentSession.SessionSetups?.find((setup) => setup?.Id === options.targetSetupId && IsPlateCorSetup(setup))
    : currentSession.SessionSetups?.find((setup) => IsPlateCorSetup(setup));
  const sourcePlateSetup = options.sourceSetupId
    ? sourceSession.SessionSetups?.find((setup) => setup?.Id === options.sourceSetupId && IsPlateCorSetup(setup))
    : sourceSession.SessionSetups?.find((setup) => IsPlateCorSetup(setup));

  if (!targetPlateSetup) {
    throw new Error('Current session does not contain a Plate setup.');
  }

  if (!sourcePlateSetup) {
    throw new Error('Selected session does not contain a Plate setup.');
  }

  const sourceShots = Array.isArray(sourcePlateSetup.Shots) ? sourcePlateSetup.Shots : [];

  if (sourceShots.length === 0) {
    throw new Error('Selected session Plate setup has no shots to import.');
  }

  const shouldReplace = options.replaceExisting !== false;
  const existingShots = shouldReplace
    ? []
    : (Array.isArray(targetPlateSetup.Shots) ? targetPlateSetup.Shots : []);
  const startingShotNumber = shouldReplace ? 1 : GetNextShotNumberFromSetup(targetPlateSetup);
  const importedShots = buildImportedPlateShots(sourceShots, startingShotNumber);

  currentSession.SessionSetups = currentSession.SessionSetups.map((setup) => {
    if (setup.Id !== targetPlateSetup.Id) {
      return setup;
    }

    return {
      ...setup,
      Shots: [...existingShots, ...importedShots]
    };
  });

  return currentSession;
}

export const ImportPlateShotsFromSession = async (sourceSessionId, options = {}) => {
  if (!sourceSessionId) {
    throw new Error('A source session id is required.');
  }

  const currentSession = GetCurrentSession();

  if (!currentSession?.id) {
    throw new Error('No current session is loaded.');
  }

  const sourceSession = await LoadSession(sourceSessionId, true);

  if (currentSession.id === sourceSessionId && options.targetSetupId && options.sourceSetupId && options.targetSetupId === options.sourceSetupId) {
    throw new Error('Cannot import Plate shots from the same Plate setup.');
  }

  SetCurrentSession(ImportPlateShotsFromSessionFunc(currentSession, sourceSession, options));
  await UpdateCurrentSession({
    origin: 'importPlateShots',
    func: ImportPlateShotsFromSessionFunc,
    params: {
      sourceSession: sourceSession,
      options: options
    }
  });

  return GetCurrentSession();
}

function MoveShotFromToSetupFunc(session, oldSetupId, newSetupId, shotNumber){
  const currentSession = session;
  const oldSetup = currentSession.SessionSetups.find(setup => setup.Id === oldSetupId);
  const newSetup = currentSession.SessionSetups.find(setup => setup.Id === newSetupId);

  const shotIndex = oldSetup.Shots.findIndex(shot => shot.ShotNumber === shotNumber);

  if (shotIndex === -1) {
    console.error(`ShotNumber ${shotNumber} not found in source.`);
    return;
  }

  const [movedShot] = oldSetup.Shots.splice(shotIndex, 1);

  movedShot.ShotNumber = GetNextShotNumberFromSetup(newSetup);

  if(newSetup.Shots === null || newSetup.Shots === undefined){
    newSetup.Shots = [];
  }

  newSetup.Shots.push(movedShot);

  currentSession.SessionSetups.map(setup => setup.Id === oldSetup.Id ? oldSetup : setup);
  currentSession.SessionSetups.map(setup => setup.Id === newSetup.Id ? newSetup : setup);

  return currentSession;
}

export const ReplaceShot = async (sessionId, setupId, newShotNum, replacingShotNum) => {
  const currentSession = await LoadSession(sessionId, true);
  const currentSetup = currentSession.SessionSetups.find(setup => setup.Id === setupId);
  const newShotIndex = currentSetup.Shots.findIndex(shot => shot.ShotNumber === newShotNum);
  const toReplaceShotIndex = currentSetup.Shots.findIndex(shot => shot.ShotNumber === replacingShotNum);
  const movingShot = currentSetup.Shots[newShotIndex];
  movingShot.ShotNumber = currentSetup.Shots[toReplaceShotIndex].ShotNumber;
  currentSetup.Shots[toReplaceShotIndex] = movingShot;
  currentSetup.Shots.splice(newShotIndex,1);
  currentSession.SessionSetups.map(setup => setup.Id === currentSetup.Id ? currentSetup : setup);

  SetCurrentSession(currentSession);

  await UpdateCurrentSession();

  return {
    session: currentSession,
    setup: currentSetup,
    shot: movingShot
  };
}

export const UpdateSetups = async (setups) => {
  let currentSession = GetCurrentSession();
  SetCurrentSession(UpdateSetupsFunc(currentSession, setups));
  await UpdateCurrentSession({
        origin:'updateSetups',
        func:UpdateSetupsFunc,
        params:{
          setups:setups
        }
      });
}

function UpdateSetupsFunc(session, setups){
  let currentSession = session;
  currentSession.SessionSetups = setups;
  return currentSession;
}

export const FinalizeSession = async () => {
  let currentSession = GetCurrentSession();

  currentSession.TaskFinished = true;

  SetCurrentSession(currentSession);
  await UpdateCurrentSession();
}

const UPDATE_SESSION_DEBOUNCE_MS = 200;

export const _updateCurrentSessionImpl = async (processData) => {
  let currentSession = GetCurrentSession();
  try{
    await UpsertSession(currentSession);
    // console.log('pass ' + processData.origin);
  }catch(e){
    if(e.message === "HTTP error 412"){
      console.log('412');
      if(processData !== null && processData !== undefined){
        //merge and re-upsert
        const event = new CustomEvent('upsertSessionError', { detail: 
          {
            type:"412",
            message:"Session was altered from an external source. Merging with that session."
          }
        });
        window.dispatchEvent(event);
        await MergeSessionWithNewVersion(currentSession, processData);
      }else{
        const event = new CustomEvent('upsertSessionError', { detail: 
          {
            type:"412",
            message:"Session was altered from an external source.\nReplacing with current session."
          }
        });
        window.dispatchEvent(event);
        await MergeSessionWithNewVersion(currentSession, 
          {
            origin:'totalStomp'
          }
        );
      }
    }else{
      const event = new CustomEvent('upsertSessionError', { detail: 
        {
          type:"other",
          message:"Updating session error:\n" + e.message
        }
       });
      window.dispatchEvent(event);
    }
  }
};

export const UpdateCurrentSession = debouncePromise(
  (processData) => withAppWorking(() => _updateCurrentSessionImpl(processData)),
  UPDATE_SESSION_DEBOUNCE_MS
);

export const MergeSessionWithNewVersion = async (oldSession, processData) => {
  //get latest session
  let latestSession = await getSessionFromId(oldSession.id);

  const origin = processData.origin;
  switch(origin){
    case "checkSetup":{//update the setup with checkmark in new session
      latestSession = processData.func(latestSession, processData.params.setup, processData.params.isChecked);
      break;
    }
    case "checkShot":{//update the shot with checkmark in new session
      latestSession = processData.func(latestSession, processData.params.setup, processData.params.shot, processData.params.isChecked);
      break;
    }
    case "selectSetup":{//stomp the selected setup from the latest session and update it with ours
      latestSession = processData.func(latestSession, processData.params.setup);
      break;
    }
    case "addSessionSetup":{//get latest setups and add our own
      latestSession = processData.func(latestSession, processData.params.setup);
      break;
    }
    case "addSessionSetupSeries":{//stomp existing setups and do our new ones
      oldSession._etag = latestSession._etag;
      latestSession = processData.func(oldSession, processData.params.setups, processData.params.series);
      break;
    }
    case "updateSetup":{//get new setup and update the values again
      latestSession = processData.func(latestSession, processData.params.setup, processData.params.keyvalues);
      break;
    }
    case "updateSetups":{//get new setups and update the values again. TODO: revisit after meeting
      latestSession = processData.func(latestSession, processData.params.setups);
      break;
    }
    case "updateCannonCor":{//get new session and update cannon cor data
      latestSession = processData.func(latestSession, processData.params.cannonCor);
      break;
    }
    case "cloneSetup":{//get new setups and then add new one
      latestSession = processData.func(latestSession, processData.params.setup, processData.params.newUpdates);
      break;
    }
    case "deleteSetup":{//get new setups and then delete the one we chose
      latestSession = processData.func(latestSession, processData.params.setupId);
      break;
    }
    case "deleteShot":{//get new session/setups and then delete the shot we picked.
      latestSession = processData.func(latestSession, processData.params.setupId, processData.params.shotNumber);
      break;
    }
    case "moveShot":{//get new session and try to move the same shot to the new setup
      latestSession = processData.func(latestSession, processData.params.oldSetupId, processData.params.newSetupId, processData.params.shotNumber);
      break;
    }
    case "checkAllSetups":{//gets new session and check/unchecks
      latestSession = processData.func(latestSession, processData.params.isChecked);
      break;
    }
    case "checkAllShots":{//gets new session and check/unchecks the shots in the setup
      latestSession = processData.func(latestSession, processData.params.setup, processData.params.isChecked);
      break;
    }
    case "totalStomp":{
      oldSession._etag = latestSession._etag;
      latestSession = oldSession;
    }
  }

  //upsert latest session
  SetCurrentSession(latestSession);
  UpdateCurrentSession();
}

function debouncePromise(fn, delay) {
  let timerId = null;
  let pendingPromise = null;
  let pendingResolve = null;
  let pendingReject = null;
  let lastArgs;
  let lastThis;

  return function (...args) {
    lastArgs = args;
    lastThis = this;

    // All callers during the debounce window share this one promise
    if (!pendingPromise) {
      pendingPromise = new Promise((resolve, reject) => {
        pendingResolve = resolve;
        pendingReject = reject;
      });
    }

    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => {
      timerId = null;
      const result = Promise.resolve(fn.apply(lastThis, lastArgs));
      result.then(pendingResolve, pendingReject);
      pendingPromise = null;
      pendingResolve = null;
      pendingReject = null;
    }, delay);

    return pendingPromise;
  };
}

export const PullTemplate = async () => {
  
  return;
}
//FileSaving

export const ExportCurrentSession = async () => {
  const session = GetCurrentSession();
  const templateSelection = getTemplateSelectionFromCookie();
  Save(await GenerateCSVSingle(session, templateSelection), true, getSessionFileName(session));
}

export const ExportCurrentSessionMultiple = async () => {
  const templateSelection = getTemplateSelectionFromCookie();
  const currentSession = GetCurrentSession();
  let sessionList = await getSessionsFromTaskId(currentSession.TaskID);

  // null / undefined
  if (sessionList == null) {
    const event = new CustomEvent("upsertSessionError", {
      detail: {
        //type:"412", 
        message: "Session was empty, can't export to csv." }
    });
    window.dispatchEvent(event);
    return;
  }

  if (!Array.isArray(sessionList)) {
    sessionList = [sessionList];
  }

  let sessions = await Promise.all(
    sessionList.map(async (id) => {
      return await getSessionFromId(id);
    })
  );

  Save(await GenerateCSVMultiple(sessions, templateSelection), true, getSessionFileName(currentSession));
}

const getSessionFileName = (session) => {
  let fileName = "";

  if(!session.Description || (session.Description && session.Description == '')){
    fileName = formatDate(session.Date);
  }else{
    fileName = sanitizeSessionDescriptionForFolder(session);
  }

  return fileName;
}

function formatDate(isoString) {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleString('en-GB', { month: 'short' });
  const year = date.getFullYear();

  return `${day}${month}${year}`;
}

function sanitizeSessionDescriptionForFolder(session) {
  // Define invalid path characters (based on Windows invalid filename characters)
  const invalidPathChars = /[<>:"/\\|?*\x00-\x1F]/g;
  
  // Replace invalid characters with an empty string
  return session.Description.replace(invalidPathChars, '');
}

export const HasMultipleSessions = async () => {
  let valid = false;
  const currentSession = GetCurrentSession();

  if(currentSession && currentSession.TaskID && currentSession.TaskID !== ''){
    const sessionList = await getSessionsFromTaskId(currentSession.TaskID);
    const sessions = Array.isArray(sessionList) ? sessionList : (sessionList ? [sessionList] : []);

    if(sessions.length > 1){
      valid = true;
    }else{
      const golferList = await getGolfersFromTaskId(currentSession.TaskID);
      const golfers = Array.isArray(golferList) ? golferList : (golferList ? [golferList] : []);

      if(golfers.length > 1){
        valid = true;
      }
    }
  }

  return valid;
}

function copyExistingSession(oldSession, newUpdates){
  let newSession = {
    ...oldSession,
    ...newUpdates
  };

  const hasBallSeries = CurrentSessionHasBallSeries();
  const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const isGuid = (value) => typeof value === 'string' && guidRegex.test(value);

  if(newSession.SessionSetups && Array.isArray(newSession.SessionSetups)){
    newSession.SessionSetups = newSession.SessionSetups
    // .filter(setup => oldSession.TaskmanImported ? (setup.TaskmanImported === true) : true) //Re-enable this to block out non-taskman-created setups
    .map(setup => ({
      ...setup,
      Id: hasBallSeries || !isGuid(setup.Id) ? setup.Id : generateGUID(),
      Shots: []
    }))
  }

  return newSession;
};

function createNewSessionObject(data, dataSource){

  const appState = AppStateService.getSnapshot();

  return {
      id: generateGUID(),
      TaskID: data.TaskId,
      Description: data.Description,
      ProjectID: data.ProjectId,
      TestID: data.TestId,
      DataSource: dataSource,
      DataCollectorId: data.DataCollector.id,
      DataCollectorName: data.DataCollector.FullName,
      UserId: data.Golfer.id,
      UserName: data.Golfer.FullName,
      UserHandicap: Number.isFinite(data.Golfer.Handicap) ? data.Golfer.Handicap : -9999,
      VenueID: data.Venue.VenueId,
      VenueName: data.Venue.Name,
      SiteID: null,
      Date: formatDateUTC(),
      DateLocal: formatDateLocal(),
      WebDataVersion: packageJson.version,
      AppDataVersion: appState.InApp ? appState.AppVersion : "0.0.0.0",
      PressureMmHg: null,
      TemperatureF: null,
      Humidity: null,
      WindDirection: null,
      WindSpeedMph: null,
      LaunchMonitorMode: data.Mode,
      BallSeries: null,
      CurrentTarget: null,
      Targets: null,
      CurrentBay: null,
      Bays: null,
      SessionSetups: null,
      TaskFinished: false,
      TaskmanImported: false,
      SoundSession: data.SoundSession ? data.SoundSession : false,
      ModifiedBy: data.ModifiedBy
  };
};

function generateGUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
};

function formatDateLocal() {
  const date = new Date();
  const timezoneOffset = -date.getTimezoneOffset(); // Offset in minutes
  const offsetHours = String(Math.floor(timezoneOffset / 60)).padStart(2, '0');
  const offsetMinutes = String(timezoneOffset % 60).padStart(2, '0');
  const offsetSign = timezoneOffset >= 0 ? '+' : '-';
  
  const localISO = date.getFullYear() +
      '-' + String(date.getMonth() + 1).padStart(2, '0') +
      '-' + String(date.getDate()).padStart(2, '0') +
      'T' + String(date.getHours()).padStart(2, '0') +
      ':' + String(date.getMinutes()).padStart(2, '0') +
      ':' + String(date.getSeconds()).padStart(2, '0') +
      offsetSign + offsetHours + ':' + offsetMinutes;

  return localISO;
};

const toLocalISOString = (d = new Date()) => {
  // ISO without timezone (local time): "YYYY-MM-DDTHH:mm:ss"
  const pad = n => String(n).padStart(2, "0");
  const yyyy = d.getFullYear();
  const mm = pad(d.getMonth() + 1);
  const dd = pad(d.getDate());
  const hh = pad(d.getHours());
  const mi = pad(d.getMinutes());
  const ss = pad(d.getSeconds());
  return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
};

const minutesBetween = (later, earlier) => {
  // Accepts Date or parseable string
  const d1 = later instanceof Date ? later : new Date(later);
  const d2 = earlier instanceof Date ? earlier : new Date(earlier);
  return (d1 - d2) / 60000;
};

async function UpsertModifiedByList(list, item, maxSize = 5, now = new Date()) {
  const { Type, User, IP } = item;
  const nowLocalISO = toLocalISOString(now);

  // Find existing entry by User+IP
  const idx = list.findIndex(e => e.User === User && e.IP === IP);

  if (idx !== -1) {
    const existing = list[idx];
    const delta = minutesBetween(now, existing.Time);

    if (delta >= 30) {
      // Add a new object
      list.push({ Type, User, Time: nowLocalISO, IP });
    } else {
      // Update timestamp (and optionally Type)
      existing.Time = nowLocalISO;
      existing.Type = Type; // remove this line if you DON'T want Type to change
    }
  } else {
    // No match -> add new entry
    list.push({ Type, User, Time: nowLocalISO, IP });
  }

  // Sort newest first
  list.sort((a, b) => new Date(b.Time) - new Date(a.Time));

  // Trim to max size (keep the most recent)
  if (list.length > maxSize) list.length = maxSize;

  return list;
}

function formatDateUTC() {
  const date = new Date();
  return date.toISOString();
};

async function GetModifiedByObject(type){
  let user = sessionStorage.getItem('dataCollectorEmail') ?? 'No email';
  const timestamp = formatDateLocal();
  const ip = await getPublicIP();

  return {
    "Type":type,
    "User":user,
    "Time":timestamp,
    "IP":ip
  };
}

//Utils
export function GetSessionHeader(session){
  let text = "";

  if(!session)
    return "";

  if(session.Description !== null && session.Description !== ""){
    text += session.Description;
  }

  if(session.TaskID !== null && session.TaskID !== "" && isValidTaskId(session.TaskID)){
    if(session.Description !== null && session.Description !== ""){
      text += " (" + session.TaskID + ")";
    }else{
      text += session.TaskID;
    }

    if(session.TaskFinished){
      text += " [COMPLETED]";
    }
  }

  if(text === ""){
    text += formatDateLocal(session.Date);
  }

  return text;
}

export function GetSetupHeader(setup){
  const normalizedClubName = (setup.ClubName || "").trim();
  const isEmptyClubName = normalizedClubName === "" || normalizedClubName.toLowerCase() === "none" || normalizedClubName.toLowerCase() === "nothing";
  let clubString = "";
  if (!isEmptyClubName && normalizedClubName === "Prototype") {

      if(setup.ClubDescription){
          clubString = setup.ClubDescription + (setup.ClubId ? ` [${setup.ClubId}]` : "");
      }else{
          clubString = normalizedClubName + (setup.ClubId ? ` [${setup.ClubId}]` : "");
      }
  } else if (!isEmptyClubName && normalizedClubName === "Custom") {
      clubString = normalizedClubName + (setup.ClubId ? ` [${setup.ClubId}]` : "");
  } else if (!isEmptyClubName) {
      clubString = normalizedClubName;
  }

  let ballString = "";
  if(setup.BallName === "Prototype"){
      if(setup.Id === "Setup Series" || setup.Id.includes("Series ")){
          clubString = "";
          ballString = setup.Id;
      }else{
          ballString = setup.BallName + !setup.BallPrototypeId ? "" : ("[" + setup.BallPrototypeId + "]");
      }
  }else if(setup.BallName === "Ball Series Testing"){
      ballString = setup.DisplayName || setup.Id || "";
  }else if(setup.BallName === "None"){
      ballString = "";
  }else{
      ballString = setup.BallName;
    }

  return [clubString, ballString].filter(Boolean).join(" ");
}


export function GetSetupLocation(setup){
    return setup.ClubDescription || setup.Id || "";
}

const DEFAULT_FAKE_SHOT_MEASUREMENTS = {
  ImpactHorizLocInch: 0.05,
  ImpactVertLocInch: 0.0,
  ImpactPathAngleDeg: -5.212,
  BallBackSpinRpm: 2994.0,
  ClosureRateDPS: 2330.149,
  ImpactPitchAngleDeg: 1.345234,
  ImpactRollAngleDeg: 0.873453,
  BallSpinRPM: 3064.1704,
  WorldStartY: 52.628025,
  ImpactAttackAngleDeg: -0.056,
  BallSideAngleDeg: -6.068992,
  BallSpeedMph: 122.035965,
  ImpactYawAngleDeg: -0.5855,
  BallLaunchAngleDeg: 8.356469,
  FaceToPath: 0.2878586,
  WorldStartZ: -589.8264,
  SmashFactor: 1.4423724,
  WorldStartX: -361.2234,
  ImpactHeadSpeedMph: 84.6078,
  BallSideSpinRpm: 652.0,
  BallSpinAxis: 12.285429,
  ShotTotalYd: 200.09578,
  ShotTotalDispFt: -12.516232,
  ShotCarryYd: 167.3885,
  ShotApexFt: 34.724464,
  ShotCarryDispFt: -16.7559,
  ShotFlightTimeSec: 4.4133697,
  ShotMaxLateralTravelFt: -19.48298,
  DistanceToApex: 105.81293
};

export const DEFAULT_FAKE_SHOT_MEASUREMENT_LIMITS = {
  ImpactHorizLocInch: { min: -1.5, max: 1.5, decimals: 1 },
  ImpactVertLocInch: { min: -1.5, max: 1.5, decimals: 1 },
  ImpactPathAngleDeg: { min: -15, max: 15, decimals: 1 },
  BallBackSpinRpm: { min: 500, max: 9000, decimals: 0 },
  ClosureRateDPS: { min: 1000, max: 4000, decimals: 0 },
  ImpactPitchAngleDeg: { min: -10, max: 30, decimals: 1 },
  ImpactRollAngleDeg: { min: -10, max: 10, decimals: 1 },
  BallSpinRPM: { min: 500, max: 10000, decimals: 0 },
  WorldStartY: { min: -1000, max: 1000, decimals: 0 },
  ImpactAttackAngleDeg: { min: -15, max: 15, decimals: 1 },
  BallSideAngleDeg: { min: -12, max: 12, decimals: 1 },
  BallSpeedMph: { min: 20, max: 190, decimals: 0 },
  ImpactYawAngleDeg: { min: -15, max: 15, decimals: 1 },
  BallLaunchAngleDeg: { min: 3, max: 20, decimals: 1 },
  FaceToPath: { min: -15, max: 15, decimals: 1 },
  WorldStartZ: { min: -1000, max: 1000, decimals: 0 },
  SmashFactor: { min: 0.2, max: 2.0, decimals: 2 },
  WorldStartX: { min: -1000, max: 1000, decimals: 0 },
  ImpactHeadSpeedMph: { min: 20, max: 150, decimals: 1 },
  BallSideSpinRpm: { min: -5000, max: 5000, decimals: 0 },
  BallSpinAxis: { min: -45, max: 45, decimals: 1 },
  ShotTotalYd: { min: 1, max: 300, decimals: 0 },
  ShotTotalDispFt: { min: -250, max: 250, decimals: 0 },
  ShotCarryYd: { min: 0, max: 290, decimals: 0 },
  ShotApexFt: { min: 0, max: 200, decimals: 0 },
  ShotCarryDispFt: { min: -250, max: 250, decimals: 0 },
  ShotFlightTimeSec: { min: 0.1, max: 10, decimals: 1 },
  ShotMaxLateralTravelFt: { min: -250, max: 250, decimals: 0 },
  DistanceToApex: { min: 0, max: 300, decimals: 0 }
};

const DEFAULT_FAKE_COR_SHOT_MEASUREMENTS = {
  post_WorldStartY: 81.96423,
  post_WorldStartZ: -616.6612,
  pre_BallSideAngleDeg: -1.2589866,
  post_BallSpeedMph: 44.070187,
  post_BallSideAngleDeg: -3.57817,
  post_BallBackSpinRpm: 294,
  pre_WorldStartX: -400.78857,
  post_BallLaunchAngleDeg: 0.18266606,
  pre_WorldStartZ: -596.6734,
  pre_BallLaunchAngleDeg: -1.8046948,
  pre_BallSideSpinRpm: 29,
  post_WorldStartX: 409.38922,
  post_BallSideSpinRpm: 56,
  pre_BallBackSpinRpm: -18,
  pre_WorldStartY: 112.0674,
  post_BallSpinAxis: 10.784298,
  pre_BallSpinAxis: -58.172554,
  pre_BallSpeedMph: 90.45099,
  pre_BallSpinRPM: -34.132095,
  post_BallSpinRPM: 299.28583
};

export const DEFAULT_FAKE_COR_SHOT_MEASUREMENT_LIMITS = {
  post_WorldStartY: { min: -1000, max: 1000, decimals: 3 },
  post_WorldStartZ: { min: -1000, max: 1000, decimals: 3 },
  pre_BallSideAngleDeg: { min: -20, max: 20, decimals: 3 },
  post_BallSpeedMph: { min: 1, max: 220, decimals: 3 },
  post_BallSideAngleDeg: { min: -20, max: 20, decimals: 3 },
  post_BallBackSpinRpm: { min: -10000, max: 10000, decimals: 0 },
  pre_WorldStartX: { min: -1000, max: 1000, decimals: 3 },
  post_BallLaunchAngleDeg: { min: -45, max: 45, decimals: 3 },
  pre_WorldStartZ: { min: -1000, max: 1000, decimals: 3 },
  pre_BallLaunchAngleDeg: { min: -45, max: 45, decimals: 3 },
  pre_BallSideSpinRpm: { min: -10000, max: 10000, decimals: 0 },
  post_WorldStartX: { min: -1000, max: 1000, decimals: 3 },
  post_BallSideSpinRpm: { min: -10000, max: 10000, decimals: 0 },
  pre_BallBackSpinRpm: { min: -10000, max: 10000, decimals: 0 },
  pre_WorldStartY: { min: -1000, max: 1000, decimals: 3 },
  post_BallSpinAxis: { min: -90, max: 90, decimals: 3 },
  pre_BallSpinAxis: { min: -90, max: 90, decimals: 3 },
  pre_BallSpeedMph: { min: 1, max: 220, decimals: 3 },
  pre_BallSpinRPM: { min: -10000, max: 10000, decimals: 0 },
  post_BallSpinRPM: { min: -10000, max: 10000, decimals: 0 }
};

function randomBetween(min, max, decimals = 3){
  const nextValue = min + (Math.random() * (max - min));
  return Number(nextValue.toFixed(decimals));
}

function buildRandomFakeShotMeasurements(limits = DEFAULT_FAKE_SHOT_MEASUREMENT_LIMITS){
  return Object.fromEntries(
    Object.entries(DEFAULT_FAKE_SHOT_MEASUREMENTS).map(([key, defaultValue]) => {
      const range = limits?.[key];

      if(!range){
        return [key, defaultValue];
      }

      return [key, randomBetween(range.min, range.max, range.decimals ?? 3)];
    })
  );
}

function buildRandomFakeCorShotMeasurements(limits = DEFAULT_FAKE_COR_SHOT_MEASUREMENT_LIMITS){
  return Object.fromEntries(
    Object.entries(DEFAULT_FAKE_COR_SHOT_MEASUREMENTS).map(([key, defaultValue]) => {
      const range = limits?.[key];

      if(!range){
        return [key, defaultValue];
      }

      return [key, randomBetween(range.min, range.max, range.decimals ?? 3)];
    })
  );
}

function buildEmulatedShot(currentSession, currentSetup, measurements){
  const maxShotNumber = Array.isArray(currentSetup?.Shots) && currentSetup.Shots.length > 0
    ? Math.max(...currentSetup.Shots.map(shot => shot?.ShotNumber ?? 0))
    : 0;

  return {
    ShotNumber: maxShotNumber + 1,
    TimeStamp: formatDateUTC(),
    TimeStampLocal: formatDateLocal(),
    LMInfos:[
      {
        ShotId: null,
        LMType: "GC_QUAD",
        Measurements: measurements,
        MotionData: null,
        CurveFit: '{\"XFit\":[0.00274946,58.65669,-7.6825676,1.0337617,-0.12825637,0.014363295,-0.00082617195],\"YFit\":[-0.0011424607,-6.2229466,2.0250974,-0.31378695,0.0371604,-0.003726225,0.00020987257],\"ZFit\":[-0.0030683656,8.71954,-0.9110722,-0.39673868,0.052069817,-0.0052594934,0.00032794656],\"TimeInterval\":[0.0,4.4],\"MeasuredTimeInterval\":[0.0,4.4]}',
        RawData: null,
        Processed: false
      }
    ],
    Highlighted: false,
    IsChecked: true,
    Group: currentSetup?.Id === "Setup Series"
      ? null
      : (currentSession?.BallSeries?.[currentSetup?.Shots?.length ?? 0] ?? null),
  };
}

function buildEmulatedCORShot(currentSession, currentSetup, measurements){
  const maxShotNumber = Array.isArray(currentSetup?.Shots) && currentSetup.Shots.length > 0
    ? Math.max(...currentSetup.Shots.map(shot => shot?.ShotNumber ?? 0))
    : 0;

  return {
    ShotNumber: maxShotNumber + 1,
    TimeStamp: formatDateUTC(),
    TimeStampLocal: formatDateLocal(),
    LMInfos:[
      {
        ShotId: null,
        LMType: "RESEARCH_QUAD",
        Measurements: measurements,
        CurveFit: null,
        RawData: null,
        Processed: false
      }
    ],
    Highlighted: false,
    IsChecked: true,
    WeatherData: null,
    TargetIndex: -1,
    BayIndex: -1,
    SoundFileUrl: null,
    Group: null
  };
}

async function persistEmulatedShot(currentSession, currentSetup, shot){
  currentSetup.Shots.push(shot);

  currentSession.SessionSetups.map(setup => setup.Id === currentSetup.Id ? currentSetup : setup);

  await UpsertSession(currentSession);

  const newShotData = {
    Type:'newShot',
    session_id: currentSession.id,
    setup_id: currentSetup.Id,
    shot_num: shot.ShotNumber
  }

  const event = new CustomEvent('sessionUpdate', { detail: JSON.stringify(newShotData) });
  window.dispatchEvent(event);
}

export async function EmulateShot(session, setupId, IHorz, IVert, Path, Face, Attack, Loft){
  let currentSession = session;
  let currentSetup = currentSession.SessionSetups.find(setup => setup.Id === setupId);

  if(currentSetup === null || currentSetup === undefined){
    console.error("No setup found in session");
    return;
  }

  if(currentSetup.Shots === null){
    currentSetup.Shots = [];
  }

  const measurements = {
    ...DEFAULT_FAKE_SHOT_MEASUREMENTS,
    ImpactHorizLocInch: IHorz ?? DEFAULT_FAKE_SHOT_MEASUREMENTS.ImpactHorizLocInch,
    ImpactVertLocInch: IVert ?? DEFAULT_FAKE_SHOT_MEASUREMENTS.ImpactVertLocInch,
    ImpactPathAngleDeg: Path ?? DEFAULT_FAKE_SHOT_MEASUREMENTS.ImpactPathAngleDeg,
    ImpactPitchAngleDeg: Loft ?? DEFAULT_FAKE_SHOT_MEASUREMENTS.ImpactPitchAngleDeg,
    ImpactAttackAngleDeg: Attack ?? DEFAULT_FAKE_SHOT_MEASUREMENTS.ImpactAttackAngleDeg,
    ImpactYawAngleDeg: Face ?? DEFAULT_FAKE_SHOT_MEASUREMENTS.ImpactYawAngleDeg
  };

  let shot = buildEmulatedShot(currentSession, currentSetup, measurements);

  await persistEmulatedShot(currentSession, currentSetup, shot);
}

export async function EmulateRandomShot(session, setupId, limits = DEFAULT_FAKE_SHOT_MEASUREMENT_LIMITS){
  let currentSession = session;
  let currentSetup = currentSession.SessionSetups.find(setup => setup.Id === setupId);

  if(currentSetup === null || currentSetup === undefined){
    console.error("No setup found in session");
    return;
  }

  if(currentSetup.Shots === null){
    currentSetup.Shots = [];
  }

  const measurements = buildRandomFakeShotMeasurements(limits);
  let shot = buildEmulatedShot(currentSession, currentSetup, measurements);

  await persistEmulatedShot(currentSession, currentSetup, shot);
}

export async function EmulateRandomCORShot(session, setupId, limits = DEFAULT_FAKE_COR_SHOT_MEASUREMENT_LIMITS){
  let currentSession = session;
  let currentSetup = currentSession.SessionSetups.find(setup => setup.Id === setupId);

  if(currentSetup === null || currentSetup === undefined){
    console.error("No setup found in session");
    return;
  }

  if(currentSetup.Shots === null){
    currentSetup.Shots = [];
  }

  const measurements = buildRandomFakeCorShotMeasurements(limits);
  let shot = buildEmulatedCORShot(currentSession, currentSetup, measurements);

  await persistEmulatedShot(currentSession, currentSetup, shot);
}
export async function EmulateCORShot(session, setupId){
  let currentSession = session;
  let currentSetup = currentSession.SessionSetups.find(setup => setup.Id === setupId);

  if(currentSetup === null || currentSetup === undefined){
    console.error("No setup found in session");
    return;
  }

  if(currentSetup.Shots === null){
    currentSetup.Shots = [];
  }

  let shot = buildEmulatedCORShot(currentSession, currentSetup, DEFAULT_FAKE_COR_SHOT_MEASUREMENTS);

  await persistEmulatedShot(currentSession, currentSetup, shot);
}
